exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.excel-upload-input[data-v-3ff25a2c]{\n  display: none;\n  z-index: -9999;\n}\n.drop[data-v-3ff25a2c]{\n  border: 2px dashed #bbb;\n  width: 80%;\n  height: 30%;\n  line-height: 160px;\n  margin: 0 auto;\n  font-size: 24px;\n  border-radius: 5px;\n  text-align: center;\n  color: #bbb;\n  position: relative;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3ff25a2c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/UploadExcel/index.vue
// module id = nkP+
// module chunks = 1